import Router from 'vue-router'
import Vue from 'vue'
import Jsrsasign from 'jsrsasign'
import authentication from 'services/authentication'

const router = new Router()
const AUTH_URL = '/authista/api/v1/auth'
const JWT_KEY = 'backoffice_jwt'

export default{
  login (context, email, password) {
    var body = {
      credentials: {
        email: email,
        password: password
      },
      options: {
        service: 'backoffice'
      }
    }
    context.$http.post(AUTH_URL, body).then(response => {
      localStorage.setItem(JWT_KEY, response.body.data.jwt)
      router.push('/')
    }, error => {
      context.errors.add('login', error.body.errors.detail, 'authorized', 'auth')
    })
  },

  logout () {
    localStorage.removeItem(JWT_KEY)
    router.push('/pages/login')
  },

  loggedIn () {
    Vue.http.headers.common = authentication.getAuthHeader()
    return localStorage.getItem(JWT_KEY)
  },

  getAuthHeader () {
    return {
      'X-Authentication': localStorage.getItem(JWT_KEY)
    }
  },
  user () {
    var jwt = this.decodeJWT()
    return {
      email: jwt.email,
      groups: jwt.groups
    }
  },
  decodeJWT () {
    var token = localStorage.getItem(JWT_KEY)
    return Jsrsasign.KJUR.jws.JWS.parse(token).payloadObj
  }
}



// WEBPACK FOOTER //
// ./src/services/authentication.js